module.exports = __webpack_public_path__ + "dbb7c76a12bd7d857f8b2eced152d48e.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/csgo/inferno.png
// module id = 1048
// module chunks = 0